import { render, staticRenderFns } from "./Gaps.vue?vue&type=template&id=a716f05c&"
import script from "./Gaps.vue?vue&type=script&lang=ts&"
export * from "./Gaps.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports